// A tiny go-between so any file (the player, the API helper) can open the 18+ age check pop-up
// without importing the pop-up itself. components/AgeGate.js plugs its "show" function in here.
let show = () => {};

export function setAgeGateShow(fn) { show = typeof fn === "function" ? fn : () => {}; }

// video = the explicit song that was clicked (or null when it is not known)
export function showAgeGateExternally(video) {
  try { show(video || null); } catch { /* ignore */ }
}